<p-sidebar
    [(visible)]="ShowShippingOption"
  
    position="right"
    (onShow)="onShippingModalShow()"
    [modal]="true"
    [showCloseIcon]="true"
    styleClass="w-30rem"
    
>
     
        <app-basic-shipping 
              #basicShippingComponent
              (formSubmitted)="shippingSettingCompleted($event)"
              (formChanged)="onShippingFormChanged($event)">
            </app-basic-shipping>

</p-sidebar>

<p-sidebar
    [(visible)]="ShowPaymentOption"
  
    position="right"
    styleClass="w-30rem"
    
>
     
        <app-payment-processing 
              #paymentProcessingComponent
              >
            </app-payment-processing>

</p-sidebar>

<p-sidebar
    [(visible)]="ShowCustomerAppDemo"
    position="right"
    styleClass="w-30rem"
>
    <p-card header="Donwload Customer App Demo" class="mb-4">
        <p>Please Scan QR code to download Customer App Demo</p>

        <div class="grid text-center">
            <div class="col-6">
                <img
                    src="assets/images/customerAppPlayStore.png"
                    alt="Google Play QR"
                    width="150"
                />
                <br />
                <a href="https://play.google.com/store/apps/details?id=yourapp">
                    <img
                        src="assets/images/app.png"
                        alt="Get it on Google Play"
                        width="60"
                    />
                </a>
            </div>
            <div class="col-6">
                <img
                    src="assets/images/customerAppAppstore.png"
                    alt="App Store QR"
                    width="150"
                />
                <br />
                <a href="#">
                    <img
                        src="assets/images/app-storelogo.png"
                        alt="Download on the App Store"
                        width="60"
                    />
                </a>
            </div>
        </div>
    </p-card>

    <p-divider></p-divider>
</p-sidebar>

<p-sidebar [(visible)]="ShowPOSLinks" position="right" styleClass="w-30rem">
    <p-card header="POS Versions Available" class="mb-4">
        <div class="grid">
            <div class="col-6">
                <h5>POS Light</h5>
                <p>Lightweight, fast, and perfect for small businesses.</p>
            </div>
            <div class="col-6">
                <h5>POS Pro</h5>
                <p>
                    Full-featured version with inventory, Cash Management, and
                    multi-user support.
                </p>
            </div>
        </div>
    </p-card>
    <p>
        <p-card header="Donwload POS Lite" class="mb-4">
            <div class="grid text-center">
                <div class="col-6">
                    <img
                        src="assets/images/LINCSELLPOS_Light_PLAYstore.png"
                        alt="Google Play QR"
                        width="150"
                    />
                    <br />
                    <a
                        href="https://play.google.com/store/apps/details?id=yourapp"
                    >
                        <img
                            src="assets/images/app.png"
                            alt="Get it on Google Play"
                            width="60"
                        />
                    </a>
                </div>
                <div class="col-6">
                    <img
                        src="assets/images/LSLIGHTAPPLE.png"
                        alt="App Store QR"
                        width="150"
                    />
                    <br />
                    <a href="#">
                        <img
                            src="assets/images/app-storelogo.png"
                            alt="Download on the App Store"
                            width="60"
                        />
                    </a>
                </div>
            </div>
        </p-card>

        <p-divider></p-divider>
    </p>

    <p>
        <p-card header="Donwload POS Pro" class="mb-4">
            <p>Comes with Premium, Advanced and Enterprise plans only</p>
            <div class="grid text-center">
                <div class="col-6">
                    <img
                        src="assets/images/LINCSELLPOS_Light_PLAYstore.png"
                        alt="Google Play QR"
                        width="150"
                    />
                    <br />
                    <a
                        href="https://play.google.com/store/apps/details?id=yourapp"
                    >
                        <img
                            src="assets/images/app.png"
                            alt="Get it on Google Play"
                            width="60"
                        />
                    </a>
                </div>
                <div class="col-6">
                    <img
                        src="assets/images/LSLIGHTAPPLE.png"
                        alt="App Store QR"
                        width="150"
                    />
                    <br />
                    <a href="#">
                        <img
                            src="assets/images/app-storelogo.png"
                            alt="Download on the App Store"
                            width="60"
                        />
                    </a>
                </div>
            </div>
        </p-card>

        <p-divider></p-divider>

        <p-card header="Order Pax Hardware" class="mb-4 text-center">
            <a href="https://lincsell.com/hardware/" target="_blank">
                View Hardware options
            </a>
        </p-card>
    </p>
</p-sidebar>

<div class="card border-round configurator-wraper" *ngIf="ShowSetupProgressOnDashboard">

<!-- Sections Accordion -->
<p-accordion [multiple]="true" class="w-full" >
    <p-accordionTab
        *ngFor="let section of sections; let i = index"
        [headerStyle]="{ 'padding': '0px' }"
    >
        <ng-template pTemplate="header">
            <div class="section-header">
                <div class="section-info">
                    <h6 class="section-title">{{ section.title }}
                        <div class="section-progress">
                    <p-progressBar
                        [value]="(section.completedTasks / section.totalTasks) * 100"
                        [showValue]="false"
                        styleClass="mb-0"
                        [ngStyle]="{'width': '120px', 'height': '6px'}"
                    ></p-progressBar>
                    <span class="progress-counter">
                        {{ section.completedTasks }}/{{ section.totalTasks }}
                    </span>
                </div>
                    </h6>
                    <p class="section-description">{{ section.description }}</p>
                </div>
                
            </div>
        </ng-template>

        <!-- Nested Tasks Accordion -->
        <p-accordion [multiple]="false" class="nested-accordion">
            <p-accordionTab
                *ngFor="let task of section.tasks"
                [disabled]="(checkIfStepCompleted(task.prequisiteIDs) && checkIfStepCompleted(task.taskID)) && !task.isEditable"
                [headerStyle]="{ 'padding': '10px' }"
            >
                <ng-template pTemplate="header">
                    <div class="flex align-items-center gap-2">
                        <i
                            class="pi pi-check-circle"
                            style="color: #22c55e; font-size: 16px; font-weight: bold;"
                            *ngIf="checkIfStepCompleted(task.taskID)"
                        ></i>
                        <i
                            class="pi pi-times-circle"
                            style="color: #ef4444; font-size: 16px;"
                            *ngIf="!checkIfStepCompleted(task.taskID)"
                        ></i>
                        <span style="font-size: 14px; font-weight: 500;">{{ task.title }}</span>
                    </div>
                </ng-template>

                <p *ngIf="task.description" class="mb-3 text-color-secondary">{{ task.description }}</p>

                <p-button
                    *ngIf="task.actionText"
                    [label]="task.actionText"
                    (onClick)="performAction(task)"
                    styleClass="p-button-sm p-button-raised"
                ></p-button>
            </p-accordionTab>
        </p-accordion>
    </p-accordionTab>
</p-accordion>
</div>